import _ from "lodash";
import React from "react";
import { useHistory } from "react-router-dom";
import useLeague from "../../hooks/queryResults/useLeague";
import useWeek from "../../hooks/queryResults/useWeek";
import Util from "../../util/util";
import Dropdown from "../ui/Dropdown";

export default function WeekLinksDropdown({ path }) {
  const history = useHistory();
  const { league } = useLeague();
  const { selectedWeek, totalNumWeeks } = useWeek();

  if (!(league && selectedWeek)) return null;

  const handleSelectWeek = (weekItem) => {
    const week = weekItem.id;
    if (week === selectedWeek) return null;

    const linkPath = Util.addWeekToPath(week, path);
    history.push(linkPath);
  };

  let weeks = _.range(1, totalNumWeeks + 1).map((weekNum) => ({
    id: weekNum,
    value: `Week ${weekNum}`,
  }));

  return (
    <Dropdown
      items={weeks}
      selectedId={selectedWeek}
      handleSelectItem={handleSelectWeek}
    />
  );
}
